import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=83651674"
import script from "./RegistrationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&lang=js"
import style0 from "./RegistrationModal.vue?vue&type=style&index=0&id=83651674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports